import React from "react";

const SharePopup = ({ onClose, id, folderName }) => {
  const copyLink = () => {
    const url = `https://www.narendramodi.in/photo-gallery/${id}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        alert("Link copied to clipboard!");
        onClose();
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  const shareOnFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=https://www.narendramodi.in/photo-gallery/${id}`,
      "_blank"
    );
  };

  const shareOnTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=https://www.narendramodi.in/photo-gallery/${id}&text=${folderName}`,
      "_blank"
    );
  };

  const shareOnWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${folderName}: https://www.narendramodi.in/photo-gallery/${id}`,
      "_blank"
    );
  };

  return (
    <div className="sharepopup_bg">
      <div className="sharepopup_pos">
        <h5>
          <span>Share</span>{" "}
          <img src="/assets/images/crosscircle.svg" alt="" onClick={onClose} />
        </h5>
        <ul className="social_list">
          <li title="copy link">
            <a onClick={copyLink} style={{ cursor: "pointer" }}>
              <img src="/assets/images/copypopup.svg" alt="" />
            </a>
          </li>
          <li className="facebook_brd">
            <a onClick={shareOnFacebook} style={{ cursor: "pointer" }}>
              <img src="/assets/images/facebook.svg" alt="" />
            </a>
          </li>

          <li className="twiiter_brd">
            <a onClick={shareOnTwitter} style={{ cursor: "pointer" }}>
              <img src="/assets/images/twiiterblack.svg" alt="" />
            </a>
          </li>

          <li>
            <a onClick={shareOnWhatsApp} style={{ cursor: "pointer" }}>
              <img src="/assets/images/whatsapp.svg" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SharePopup;
